// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seo-content[data-v-fbd1c858]{width:100%;padding:0 6%;max-width:100%;text-align:left}.seo-content h1[data-v-fbd1c858]{font-size:22px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
